import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-tongue-wink': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M152 180c25.7 0 55.9 16.9 59.8 42.1 0.8 5-1.7 10-6.1 12.4-5.7 3.1-11.2 0.6-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0l-9.5 8.5c-3.8 3.4-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 3.9-25.2 34.1-42.1 59.8-42.1zM328 128c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80zM328 256c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM328 184c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM312 408h0.1v-43.8l-17.7-8.8c-15.1-7.6-31.5 1.7-34.9 16.5l-2.8 12.1c-2.1 9.2-15.2 9.2-17.3 0l-2.8-12.1c-3.4-14.8-19.9-24-34.9-16.5l-17.7 8.8v42.8c0 35.2 28 64.5 63.1 65 35.8 0.5 64.9-28.4 64.9-64zM340.2 433.3c64-33.4 107.8-100.3 107.8-177.3 0-110.3-89.7-200-200-200s-200 89.7-200 200c0 77 43.8 143.9 107.8 177.3-2.2-8.1-3.8-16.5-3.8-25.3v-43.5c-14.2-12.4-24.4-27.5-27.3-44.5-1.7-10 7.8-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1c10-3.2 19.4 5.4 17.7 15.3-2.9 17-13.1 32.1-27.3 44.5v43.5c0 8.8-1.6 17.2-3.8 25.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-tongue-wink.js
// module id = 1759
// module chunks = 0